/*
 * @Date: 2023-11-08 16:07:08
 * @LastEditors: lihwang
 * @LastEditTime: 2023-11-08 16:38:48
 * @FilePath: /ckb-mall-web/src/common/CKBLayout/modules/HomeModal/index.tsx
 * @Description:
 * @Author: lihwang
 */
import { useEffect, useState } from 'react';
import { Modal } from 'antd';
import { useRequest, useLocalStorageState } from 'ahooks';
import { PopupRespDTO } from '@/service/market';
import { request } from '@/config/request';
import CancelCircle from '@/common/icons/CancelCircle';
import { urlAddChannel } from '@/utils';
import styles from './index.scss';

// 首页弹窗
const HomeModal = () => {
    // 获取弹窗
    const { runAsync: apiGetModal } = useRequest(request.market.popup.show, {
        manual: true
    });
    const [showModal, setShowModal] = useState<boolean>(false);
    // 弹窗数据
    const [modalData, setModalData] = useState<PopupRespDTO>({});
    // 弹窗更新时间
    const [updateTime, setUpdateTime] = useLocalStorageState<string>(
        'easy-popup-updateTime',
        {
            defaultValue: ''
        }
    );
    useEffect(() => {
        apiGetModal({
            bizScene: '1',
            sourceChannel: '1'
        }).then((res) => {
            if (res.success && res.data) {
                // 只有当弹窗数据发生变化时才弹出新弹窗，依据为更新时间
                if (res.data?.updateTime !== updateTime) {
                    setShowModal(true);
                    setModalData(res.data || {});
                }
            }
        });
    }, [apiGetModal, updateTime, setShowModal, setUpdateTime]);
    const imgClick = () => {
        if (modalData.jumpUrl) {
            // window.open(modalData.jumpUrl);
            window.open(urlAddChannel(modalData.jumpUrl));
            setShowModal(false);
            setUpdateTime(modalData.updateTime);
        }
    };
    return (
        <Modal
            title=""
            open={showModal}
            classNames={{
                header: styles.model_header,
                content: styles.ant_modal_content
            }}
            footer={null}
            // closeIcon={null}
            className={styles.home_modal}
            onCancel={() => {
                setUpdateTime(modalData.updateTime);
                setShowModal(false);
            }}
            closeIcon={<CancelCircle size={20} />}
            width={1200}
            styles={{
                content: {
                    borderRadius: '20px'
                }
            }}
        >
            <img
                className={styles.search_logo}
                src={modalData?.picUrl}
                alt="logo"
                onClick={imgClick}
            />
        </Modal>
    );
};
export default HomeModal;
